<form
  #editAvailabilityForm="ngForm"
  (keydown.enter)="$event.preventDefault()">
  <div mat-dialog-title>
    <h1 mat-dialog-title>{{ data.personName }}</h1>
  </div>
  <div mat-dialog-content>
    <div class="date-row">
      <div class="date-select">
        <mat-form-field class="light-form-field time-selection">
          <mat-label>{{
            ("employmentDuration" | i18n) || "Einsatzdauer" | titlecase
          }}</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input
              matStartDate
              required
              name="fromDate"
              [ngModel]="data.startDate"
              (ngModelChange)="updateStartDate($event)"
              (click)="picker.open()" />
            <input
              matEndDate
              required
              name="toDate"
              [ngModel]="data.endDate"
              (ngModelChange)="updateEndDate($event)"
              (click)="picker.open()" />
          </mat-date-range-input>
          <mat-icon
            *ngIf="
              (managementService.fromParamDate$ | async) &&
              (managementService.toParamDate$ | async)
            "
            svgIcon="close"
            class="clear-date-icon"
            (click)="clearDates(); $event.stopPropagation()"></mat-icon>
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
      <div class="workload-select">
        <mat-form-field class="light-form-field">
          <mat-label>
            {{ ("workloadInPercent" | i18n) || "Pensum in %" | titlecase }}
          </mat-label>
          <input
            matInput
            [(ngModel)]="data.workload"
            name="workload"
            type="number"
            min="0"
            max="100"
            required
            data-cy="workload-input" />
        </mat-form-field>
      </div>
    </div>

    <app-department-select
      class="light-form-field"
      [required]="true"
      [autoSelectOnlyDepartment]="true"
      (departmentSelectionChanged)="updateDepartment($event)"
      [selectedDepartmentId]="data.departmentId"></app-department-select>
  </div>
  <div
    mat-dialog-actions
    class="dialog-action-buttons">
    <button
      type="button"
      class="outline-pill-button"
      (click)="closeDialog()">
      {{ ("cancel" | i18n) || "cancel" | uppercase }}
    </button>
    <button
      type="button"
      class="primary-pill-button icon-left"
      [disabled]="!data.startDate || !data.endDate || !data.departmentId"
      [mat-dialog-close]="{
        startDate: data.startDate,
        endDate: data.endDate,
        departmentId: data.departmentId,
        workload: data.workload
      }"
      data-cy="availability-edit-submit-button">
      <mat-icon svgIcon="add-circle-plus"></mat-icon>
      <span class="mat-fab__label">{{
        ("create" | i18n) || "erstellen" | uppercase
      }}</span>
    </button>
  </div>
</form>
